import angular from 'angular';

import RapportsActivitesRoute from './_config/rapports.activites.routes';
import RapportsActivitesConfiguration from './_config/rapports.activites.config';

import RapportsActivitesComponent from './components/rapports-activites';
import ModalSecteurComponent from './components/modal-secteur';
import RapportsOrganisationProduitsController from './components/rapports-organisation-produits';

import RapportsActivitesService from './services/rapports.activites.service';

const moduleName = 'app.massia.gestion.rapports.activites';

angular
	.module(moduleName, [])
	.config(RapportsActivitesRoute)
	.config(RapportsActivitesConfiguration)
	.service('RapportsActivitesService', RapportsActivitesService)
	.component('rapportsActivites', RapportsActivitesComponent)
	.component('modalSecteur', ModalSecteurComponent)
	.component('rapportsOrganisationProduits', RapportsOrganisationProduitsController);

export default moduleName;
